import Layout from 'antd/lib/layout';
import React, { useState } from 'react';
import { INominationsSidebarFilters, useNominationsSidebarFiltersContext } from './NominationSidebarFiltersContext';
import { SidebarWrapper } from '../../../components/sidebar-filters/SidebarWrapper';
import Typography from 'antd/lib/typography';
import { SidebarFiltersGroupCollapse } from '../../../components/sidebar-filters/SidebarFiltersGroupCollapse';
import { NominationsSidebarTabs } from './NominationSidebarTabs';
import { ICreateSavedFilter } from '../../../components/sidebar-filters/saved-filter/interface';
import { SaveNominationFiltersModal } from './SaveNominationFiltersModal';
import { NOMINATION_PAGE_CONST } from './constants';

interface INominationSidebarProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    totalRecords?: number;
    onFilterChange: (filter: INominationsSidebarFilters) => void;
    gridComponent: React.ReactNode;
}

export const NominationSidebar: React.FC<INominationSidebarProps> = ({
    collapsed,
    onCollapseChange,
    totalRecords,
    onFilterChange,
    gridComponent,
}) => {
    const {
        selectedSavedFilter,
        handleSavedFilterSelect,
        handleCreateSavedFilter,
        isCreateFilterLoading,
        handleUpdateSavedFilter,
        isUpdateFilterLoading,
    } = useNominationsSidebarFiltersContext();

    const [saveFiltersModalOpen, setSaveFiltersModalOpen] = useState(false);

    const handleOpenSaveFiltersModal = (savedFilterData: ICreateSavedFilter | null) => {
        setSaveFiltersModalOpen(true);
        handleSavedFilterSelect(savedFilterData);
    };

    const handleCancelSaveFilters = () => {
        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    const handleSaveFilters = async (filterData: ICreateSavedFilter) => {
        const upsertSavedFilter = filterData.id ? handleUpdateSavedFilter : handleCreateSavedFilter;

        await upsertSavedFilter(filterData);

        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    return (
        <>
            <SidebarWrapper
                collapsed={collapsed}
                onCollapseChange={onCollapseChange}
                collapsedWidth={NOMINATION_PAGE_CONST.collapsedWidth}
                expandedWidth={NOMINATION_PAGE_CONST.expandedWidth}
            >
                <Layout.Content
                    style={{
                        padding: 0,
                        margin: 0,
                        height: '100%',
                    }}
                >
                    {!collapsed && (
                        <div style={{ padding: '14px 12px 8px' }}>
                            <Typography.Text>Total Records: {totalRecords}</Typography.Text>
                        </div>
                    )}
                    <SidebarFiltersGroupCollapse collapsed={collapsed} setCollapsed={onCollapseChange} selectedItemsCount={0} />

                    {!collapsed && (
                        <NominationsSidebarTabs
                            onFilterChange={onFilterChange}
                            onOpenSaveFiltersModal={handleOpenSaveFiltersModal}
                            gridComponent={gridComponent}
                        />
                    )}
                </Layout.Content>
            </SidebarWrapper>

            {/* Modals goes here === */}
            {saveFiltersModalOpen && selectedSavedFilter && (
                <SaveNominationFiltersModal
                    isLoading={isCreateFilterLoading || isUpdateFilterLoading}
                    initialSavedFilter={selectedSavedFilter}
                    onCancel={handleCancelSaveFilters}
                    onSave={handleSaveFilters}
                />
            )}
        </>
    );
};
